<template>
	<svg
		:fill="fillColor"
		:aria-label="label"
		:width="dimensions.width"
		:height="dimensions.height"
		:viewBox="viewBox"
		role="img"
		focusable="false"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			v-if="risquePro && !avatar"
			:fill="risqueProColor"
			d="M68 55.8h2.8a3 3 0 0 1 2 .6c.5.4.8 1 .8 1.8 0 .6-.2 1-.4 1.4-.2.4-.6.6-1 .9l1.8 3.3h-1.5l-1.6-3h-1.6v3H68zm2.6 3.8c.5 0 1 0 1.2-.3.2-.3.4-.6.4-1 0-1-.6-1.4-1.6-1.4h-1.3v2.7zm4.5-3.8h1.3v8H75zm5.4 8.2a6.5 6.5 0 0 1-2.7-.6L78 62c1 .5 1.9.7 2.7.7.4 0 .8 0 1-.2.3-.2.4-.5.4-.8 0-.3 0-.5-.2-.6-.1-.2-.3-.3-.6-.4l-1.1-.5a7 7 0 0 1-1.3-.5l-.8-.7a2 2 0 0 1-.2-1.1c0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2.1-.6a6.1 6.1 0 0 1 2.6.5l-.2 1.3-1.2-.4c-.4-.2-.8-.2-1.2-.2a2 2 0 0 0-1.1.2c-.2.2-.4.4-.4.7 0 .3 0 .5.2.6l.5.4 1 .3c1 .3 1.6.6 2 1 .5.4.7 1 .7 1.6 0 .6-.3 1.2-.7 1.6-.5.4-1.3.7-2.4.7zm11.7-4.2c0 1-.3 2-.8 2.7l.7.7-.8.8-.7-.7a4 4 0 0 1-2.3.7 4 4 0 0 1-2-.6c-.7-.3-1.1-.8-1.5-1.4-.3-.6-.5-1.4-.5-2.2 0-.8.2-1.6.5-2.2.4-.6.8-1 1.4-1.4a4 4 0 0 1 2-.5 4 4 0 0 1 2.1.5c.6.3 1 .8 1.4 1.4.3.6.5 1.4.5 2.2zm-4 2.9c.6 0 1-.1 1.4-.4l-1-.9.8-.8 1 .9c.3-.5.4-1 .4-1.7 0-.8-.2-1.5-.7-2-.4-.6-1-.9-1.8-.9s-1.5.3-2 .8c-.4.6-.6 1.3-.6 2.1 0 .9.2 1.6.7 2 .4.6 1 .9 1.9.9zm8.5 1.3c-1 0-1.9-.4-2.4-1-.6-.6-.9-1.5-.9-2.6v-4.6h1.3V60c0 .9.2 1.6.5 2 .2.5.8.7 1.5.7.8 0 1.3-.2 1.6-.7.3-.4.4-1.1.4-2v-4.2h1.3v4.6c0 1.1-.2 2-.8 2.6-.5.6-1.4 1-2.5 1zm5-8.2h5v1.3h-3.6v2h2.9v1.2h-3v2.2h3.9v1.3h-5.2zm8.8 8.2a6.5 6.5 0 0 1-2.7-.6l.2-1.4c1 .5 1.9.7 2.7.7.4 0 .8 0 1-.2.3-.2.4-.5.4-.8 0-.3 0-.5-.2-.6-.1-.2-.3-.3-.6-.4l-1.1-.5a7 7 0 0 1-1.3-.5l-.8-.7a2 2 0 0 1-.2-1.1c0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2.1-.6a6.1 6.1 0 0 1 2.6.5l-.2 1.3-1.3-.4c-.3-.2-.7-.2-1.1-.2a2 2 0 0 0-1.1.2c-.3.2-.4.4-.4.7 0 .3 0 .5.2.6l.5.4 1 .3c1 .3 1.6.6 2 1 .5.4.7 1 .7 1.6 0 .6-.3 1.2-.7 1.6-.5.4-1.3.7-2.4.7zm6.9-8.2h2.7c1.9 0 2.8.9 2.8 2.6 0 .9-.2 1.5-.7 2-.5.4-1.2.6-2 .6h-1.5v2.8h-1.3zm2.6 4c.5 0 1 0 1.2-.3.2-.2.4-.6.4-1 0-.6-.2-1-.4-1.2-.3-.2-.7-.4-1.2-.4h-1.3v3zm4-4h2.9a3 3 0 0 1 2 .6c.5.4.7 1 .7 1.8 0 .6-.1 1-.3 1.4l-1 .9 1.7 3.3h-1.5l-1.5-3h-1.6v3h-1.3zm2.6 3.8c.6 0 1 0 1.2-.3.3-.3.4-.6.4-1 0-1-.5-1.4-1.6-1.4h-1.2v2.7zm8 4.4a4 4 0 0 1-2-.6c-.6-.3-1.1-.8-1.5-1.4-.3-.6-.5-1.4-.5-2.2 0-.8.2-1.6.5-2.2.4-.6.9-1 1.4-1.4a4 4 0 0 1 2-.5 4 4 0 0 1 2.1.5c.6.3 1 .8 1.4 1.4.3.6.5 1.4.5 2.2 0 .8-.2 1.6-.5 2.2-.3.6-.8 1.1-1.4 1.4a4 4 0 0 1-2 .6zm0-1.3c.8 0 1.4-.3 1.9-.8.4-.5.6-1.2.6-2 0-1-.2-1.6-.6-2.2-.5-.5-1.1-.8-2-.8-.7 0-1.4.3-1.8.8-.4.6-.7 1.3-.7 2.1 0 .9.3 1.6.7 2 .4.6 1 .9 1.9.9zm5.2-6.9h5v1.3h-3.6v2h2.7v1.2h-2.7v3.5h-1.4zm6 0h5v1.3h-3.6v2h2.8v1.2h-2.8v2.2h3.7v1.3h-5zm8.7 8.2a6.5 6.5 0 0 1-2.6-.6l.2-1.4c1 .5 1.9.7 2.7.7.4 0 .8 0 1-.2.3-.2.4-.5.4-.8 0-.3 0-.5-.2-.6l-.6-.4-1.2-.5a7 7 0 0 1-1.2-.5l-.8-.7a2 2 0 0 1-.3-1.1c0-.7.3-1.2.8-1.6.5-.4 1.2-.6 2.1-.6a6.1 6.1 0 0 1 2.5.5v1.3l-1.4-.4c-.4-.2-.8-.2-1.2-.2a2 2 0 0 0-1 .2c-.3.2-.4.4-.4.7 0 .3 0 .5.2.6l.5.4 1 .3c1 .3 1.6.6 2 1 .4.4.7 1 .7 1.6 0 .6-.3 1.2-.8 1.6-.4.4-1.2.7-2.4.7zm6.7 0a6.5 6.5 0 0 1-2.7-.6l.2-1.4c1 .5 1.9.7 2.7.7.4 0 .8 0 1-.2.3-.2.4-.5.4-.8 0-.3 0-.5-.2-.6-.1-.2-.3-.3-.6-.4l-1.1-.5a7 7 0 0 1-1.3-.5l-.7-.7a2 2 0 0 1-.3-1.1c0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2.2-.6a6.1 6.1 0 0 1 2.5.5l-.2 1.3-1.2-.4c-.4-.2-.8-.2-1.2-.2a2 2 0 0 0-1 .2c-.3.2-.5.4-.5.7l.2.6.5.4 1 .3c1 .3 1.6.6 2 1 .5.4.7 1 .7 1.6 0 .6-.3 1.2-.7 1.6-.5.4-1.3.7-2.4.7zm4.3-8.2h1.3v8h-1.3zm6.6 8.2a4 4 0 0 1-2-.6c-.6-.3-1.1-.8-1.4-1.4-.4-.6-.6-1.4-.6-2.2 0-.8.2-1.6.6-2.2.3-.6.8-1 1.4-1.4a4 4 0 0 1 2-.5 4 4 0 0 1 2 .5c.6.3 1 .8 1.4 1.4.4.6.5 1.4.5 2.2 0 .8-.1 1.6-.5 2.2-.3.6-.8 1.1-1.4 1.4a4 4 0 0 1-2 .6zm0-1.3c.8 0 1.4-.3 1.9-.8.4-.5.6-1.2.6-2 0-1-.2-1.6-.6-2.2-.5-.5-1.1-.8-2-.8-.7 0-1.4.3-1.8.8-.4.6-.7 1.3-.7 2.1 0 .9.3 1.6.7 2 .4.6 1 .9 1.9.9zm5.2-6.9h1.4l3.6 5.5v-5.5h1.3v8h-1l-4-5.8v5.8h-1.3zm8 0h1.4l3.6 5.5v-5.5h1.4v8h-1.1l-3.9-5.8v5.8h-1.3zm8.2 0h5v1.3h-3.7v2h2.9v1.2h-2.9v2.2h3.8v1.3h-5.1zm6.4 0h1.3v6.8h3.4v1.2H200zm8 8.2a6.5 6.5 0 0 1-2.6-.6l.1-1.4c1 .5 1.9.7 2.7.7.4 0 .8 0 1-.2.3-.2.4-.5.4-.8 0-.3 0-.5-.2-.6-.1-.2-.3-.3-.6-.4l-1.1-.5a7 7 0 0 1-1.2-.5c-.4-.2-.6-.4-.8-.7a2 2 0 0 1-.3-1.1c0-.7.2-1.2.7-1.6.5-.4 1.2-.6 2.2-.6a6.1 6.1 0 0 1 2.5.5l-.1 1.3-1.3-.4c-.4-.2-.8-.2-1.2-.2a2 2 0 0 0-1 .2c-.3.2-.4.4-.4.7l.1.6.6.4 1 .3c.9.3 1.5.6 2 1 .4.4.6 1 .6 1.6 0 .6-.2 1.2-.7 1.6-.5.4-1.3.7-2.4.7z"
		/>

		<g v-else-if="!hideSignature && !avatar">
			<path d="M69.2 55.3h1.3l2.1 6.5h-1.2l-1-3.4-.6-2.1-.6 2-1 3.5H67l2.2-6.5Zm-.9 3.9h3v.9h-3v-1Z" />

			<path d="M73.3 62.7c0-.4.3-.7.7-1a.9.9 0 0 1-.4-.8c0-.4.2-.8.5-1-.3-.2-.7-.7-.7-1.3 0-1.1 1-1.7 2-1.7h2.4v1H77c.2 0 .3.4.3.7 0 1.1-.8 1.7-1.8 1.7l-.7-.1-.2.4c0 .3.1.5.8.5h.8c1.2 0 1.8.3 1.8 1.2 0 1-1 1.7-2.6 1.7-1.1 0-2-.4-2-1.3Zm3.6-.2c0-.4-.3-.5-1-.5h-1.2c-.3.1-.4.4-.4.6 0 .4.5.7 1.2.7.8 0 1.4-.4 1.4-.8Zm-.7-3.9c0-.6-.3-1-.8-1s-.8.4-.8 1 .3 1 .8 1 .8-.4.8-1Z" />

			<path d="M79 55.5c0-.4.3-.7.7-.7.4 0 .8.3.8.7 0 .3-.3.6-.8.6-.4 0-.7-.2-.7-.6Zm.2 1.5h1.1v4.9h-1.1v-5Z" />

			<path d="M82.1 57h1v.8c.4-.6 1-1 1.4-1l.6.2-.2 1-.5-.1c-.4 0-.9.2-1.2 1v3h-1.1v-5Z" />

			<path d="M88.1 59.4c0-1.6 1.1-2.6 2.3-2.6 1.3 0 2 1 2 2.3v.6h-3.1c0 .9.6 1.4 1.4 1.4a2 2 0 0 0 1.1-.4l.4.7a3 3 0 0 1-1.6.6c-1.4 0-2.5-1-2.5-2.6Zm3.3-.5c0-.7-.3-1.2-1-1.2-.6 0-1 .5-1.1 1.2h2.1Z" />

			<path d="M93.8 57h1v.6c.5-.4 1-.8 1.7-.8 1 0 1.5.8 1.5 2v3h-1.2V59c0-.8-.2-1-.8-1-.4 0-.7.1-1 .5v3.4h-1.2V57Z" />

			<path d="m99.3 61.3.5-.7c.4.3.9.5 1.3.5.6 0 .8-.2.8-.6 0-.4-.5-.6-1-.8-.7-.2-1.4-.6-1.4-1.4 0-.8.7-1.4 1.8-1.4.7 0 1.2.3 1.6.5l-.5.7c-.3-.2-.7-.4-1-.4-.6 0-.8.2-.8.5 0 .4.5.6 1 .8.7.2 1.4.5 1.4 1.5 0 .8-.6 1.5-1.9 1.5a3 3 0 0 1-1.8-.7Z" />

			<path d="M104 59.4c0-1.6 1.1-2.6 2.3-2.6 1.3 0 2 1 2 2.3v.6h-3.1c0 .9.6 1.4 1.4 1.4a2 2 0 0 0 1.1-.4l.4.7a3 3 0 0 1-1.6.6c-1.4 0-2.5-1-2.5-2.6Zm3.3-.5c0-.7-.3-1.2-1-1.2-.6 0-1.1.5-1.2 1.2h2.2Z" />

			<path d="M109.7 57h1v.6c.5-.4 1-.8 1.6-.8.7 0 1 .4 1.3.9.5-.5 1-.9 1.5-.9 1 0 1.6.8 1.6 2v3h-1.2V59c0-.8-.2-1-.7-1-.4 0-.7 0-1 .5v3.4h-1.2V59c0-.8-.3-1-.8-1-.3 0-.6 0-1 .5v3.4h-1.2V57h.1Z" />

			<path d="m119.5 61.4-.2.5h-.9v-7h1.2v2.5c.3-.3.8-.6 1.3-.6 1.3 0 2 1 2 2.5 0 1.7-1 2.6-2.1 2.6-.4 0-1-.1-1.3-.5Zm2.2-2c0-1-.3-1.6-1-1.6-.4 0-.7.2-1.1.6v2.2c.3.3.7.4 1 .4.6 0 1.1-.5 1.1-1.6Z" />

			<path d="M124.3 60.6v-5.8h1.2v5.9c0 .3.1.4.2.4h.2l.1.8-.6.1c-.8 0-1-.6-1-1.4Z" />

			<path d="M127 59.4c0-1.6 1.1-2.6 2.3-2.6 1.3 0 2 1 2 2.3v.6H128c.2.9.7 1.4 1.5 1.4a2 2 0 0 0 1.1-.4l.4.7a3 3 0 0 1-1.7.6c-1.3 0-2.4-1-2.4-2.6Zm3.3-.5c0-.7-.3-1.2-1-1.2-.6 0-1.1.5-1.2 1.2h2.2Z" />

			<path d="M133.4 60.4c-.4 0-.8.3-.8.7 0 .5.4.7.8.7 0 .5-.3 1-1 1.2l.3.6c1-.3 1.5-1 1.5-2 0-.7-.3-1.2-.8-1.2Z" />

			<path d="M138.2 57h1v.5c.5-.4 1-.7 1.5-.7 1.3 0 2 1 2 2.5 0 1.7-1 2.7-2.1 2.7-.5 0-1-.2-1.3-.6v2.3h-1.1V57Zm3.3 2.4c0-1-.4-1.6-1-1.6-.4 0-.8.2-1.1.6v2.2c.3.3.7.4 1 .4.6 0 1-.5 1-1.6Z" />

			<path d="M144.1 57h1v.8c.4-.6 1-1 1.4-1l.6.2-.2 1-.5-.1c-.4 0-.9.2-1.2 1v3h-1.1v-5Z" />

			<path d="M147.5 59.4c0-1.6 1.2-2.6 2.4-2.6s2.3 1 2.3 2.6-1.1 2.6-2.3 2.6c-1.2 0-2.4-1-2.4-2.6Zm3.5 0c0-1-.4-1.6-1.2-1.6-.7 0-1.1.6-1.1 1.6s.4 1.6 1.1 1.6c.8 0 1.2-.6 1.2-1.6Z" />

			<path d="M153.6 60.2v-2.3h-.7V57h.8l.1-1.4h1V57h1.2v.9h-1.2v2.3c0 .6.2.9.7.9l.5-.1.2.8-1 .2c-1.1 0-1.6-.8-1.6-1.8Z" />

			<path d="M157 59.4c0-1.6 1-2.6 2.2-2.6 1.3 0 2 1 2 2.3v.6H158c.2.9.7 1.4 1.5 1.4a2 2 0 0 0 1.1-.4l.4.7a3 3 0 0 1-1.7.6c-1.3 0-2.4-1-2.4-2.6Zm3.2-.5c0-.7-.3-1.2-1-1.2-.6 0-1.1.5-1.2 1.2h2.2Zm-1.6-3.3 1.4-1.7.8.7-1.7 1.5-.5-.5Z" />

			<path d="M162.2 62.7c0-.4.3-.7.7-1a.9.9 0 0 1-.4-.8c0-.4.2-.8.5-1-.3-.2-.6-.7-.6-1.3 0-1.1.9-1.7 1.9-1.7h2.4v1h-.9c.2 0 .3.4.3.7 0 1.1-.8 1.7-1.8 1.7l-.7-.1-.2.4c0 .3.1.5.8.5h.8c1.2 0 1.8.3 1.8 1.2 0 1-1 1.7-2.6 1.7-1.1 0-2-.4-2-1.3Zm3.6-.2c0-.4-.3-.5-1-.5h-1.2c-.3.1-.4.4-.4.6 0 .4.5.7 1.3.7.7 0 1.3-.4 1.3-.8Zm-.7-3.9c0-.6-.3-1-.8-1s-.8.4-.8 1 .3 1 .8 1 .8-.4.8-1Z" />

			<path d="M167.5 59.4c0-1.6 1.1-2.6 2.3-2.6 1.3 0 2 1 2 2.3v.6h-3.1c0 .9.6 1.4 1.4 1.4a2 2 0 0 0 1.1-.4l.4.7a3 3 0 0 1-1.6.6c-1.4 0-2.5-1-2.5-2.6Zm3.3-.5c0-.7-.3-1.2-1-1.2-.6 0-1.1.5-1.2 1.2h2.2Z" />

			<path d="M173.2 57h1v.8c.4-.6 1-1 1.4-1l.6.2-.2 1-.5-.1c-.4 0-.9.2-1.2 1v3h-1.1v-5Z" />

			<path d="M179.3 59.4c0-1.6 1.1-2.6 2.4-2.6.6 0 1.1.3 1.4.6l-.5.7c-.3-.2-.5-.3-.8-.3-.8 0-1.3.6-1.3 1.6s.5 1.6 1.3 1.6c.4 0 .7-.1 1-.4l.4.8c-.4.4-1 .6-1.6.6-1.3 0-2.3-1-2.3-2.6Z" />

			<path d="M184.5 54.8h1.1v2.8c.4-.4.9-.7 1.5-.7 1.1 0 1.5.7 1.5 2v3h-1.1v-3c0-.7-.2-1-.8-1-.4 0-.7.2-1.1.6v3.4h-1.2v-7Z" />

			<path d="M190 60.5c0-1 .9-1.6 2.9-1.8 0-.5-.2-1-.9-1-.5 0-1 .3-1.4.5l-.4-.8a4 4 0 0 1 2-.6c1.2 0 1.8.8 1.8 2.1v2.9h-1v-.6c-.5.4-1 .7-1.5.7-1 0-1.5-.5-1.5-1.4Zm2.9 0v-1c-1.4.2-1.8.5-1.8 1 0 .4.3.6.7.6.4 0 .7-.2 1-.5Z" />

			<path d="M195.4 59.4c0-1.6 1.1-2.6 2.4-2.6.6 0 1.1.3 1.4.6l-.5.7c-.3-.2-.5-.3-.8-.3-.8 0-1.3.6-1.3 1.6s.5 1.6 1.3 1.6c.4 0 .7-.1 1-.4l.4.8c-.4.4-1 .6-1.5.6-1.4 0-2.4-1-2.4-2.6Z" />

			<path d="M200.5 60v-3h1.2v2.9c0 .8.2 1.1.7 1.1.5 0 .7-.2 1.1-.7V57h1.2v4.9h-1V61h-.1c-.5.5-1 .9-1.6.9-1 0-1.5-.8-1.5-2Z" />

			<path d="M206.3 57h1v.6c.5-.4 1-.8 1.7-.8 1 0 1.5.8 1.5 2v3h-1.1V59c0-.8-.2-1-.8-1-.4 0-.7.1-1.1.5v3.4h-1.2V57Z" />
		</g>

		<g v-if="!hideOrganism && !avatar">
			<path d="m3.3 32.3-.4-.4c.1-.3.3-.5.3-.8 0-.3 0-.4-.2-.4s-.3.1-.4.4l-.2.4c-.1.3-.4.6-.8.6-.5 0-.9-.5-.8-1.1 0-.4.1-.7.4-1l.4.4a1 1 0 0 0-.3.6c0 .2.1.4.3.4.2 0 .2-.2.4-.4l.1-.4c.2-.3.5-.6.9-.5.5 0 .9.5.8 1.2 0 .2-.2.7-.5 1Z" />

			<path d="M.5 28 0 27l.5-.2.4.9-.4.2Zm.4.6.3-1.8h.5L1.6 28h.6l.1-1 .6.1-.1 1 .6.2.2-1.3.6.1-.3 2-3-.5Z" />

			<path d="M2.8 26c-1-.3-1.4-1-1.2-1.8l.6-.8.3.5c-.1.1-.3.2-.3.5-.1.4.2.8.7.9.6.1 1 0 1.2-.5 0-.2 0-.4-.2-.6l.5-.3c.2.4.3.7.2 1-.1.9-.8 1.3-1.8 1Z" />

			<path d="m3.7 22.8-1.5-.5.3-.7 1.6.6c.5.2.8.1.9-.2.1-.3 0-.6-.5-.8l-1.6-.6.2-.6 1.5.6c1 .3 1.2.9 1 1.6-.4.8-1 1-1.9.6Z" />

			<path d="m3.7 18.6.5-1c.3-.6.7-1 1.4-.6.6.3.6.9.3 1.5l-.2.3 1 .5-.3.6-2.7-1.3Zm1.7-.3c.2-.3.1-.6-.2-.7-.2-.2-.4 0-.6.3l-.1.3.7.4.2-.3Zm.3.2-.2-.6h2l-.4.6H5.7Z" />

			<path d="m5.4 15.3.4-.6 2.5 1.7-.3.5-2.6-1.6Z" />

			<path d="m7.3 13.5-.5.7-.4-.4 1.4-1.9.5.4-.6.7 2 1.4-.4.6-2-1.5Z" />

			<path d="m8.5 11 1.3-1.3.5.4-.9.8.5.4.7-.7.4.4-.7.7.5.5.9-1 .4.5-1.3 1.4-2.3-2Zm.1-.7v-1h.7l-.2 1h-.5Z" />

			<path d="M13.6 9.7v-.6c.3 0 .6 0 .8-.2.2-.2.3-.4.2-.5-.2-.2-.3-.1-.6 0h-.4c-.4.2-.7.1-1-.2-.3-.4-.2-1 .3-1.4.3-.2.6-.3 1-.3v.6a1 1 0 0 0-.7.1c-.1.2-.2.4-.1.5h.6l.4-.1c.4-.1.7-.1 1 .3.2.4.2 1-.4 1.4-.3.3-.7.4-1 .4Z" />

			<path d="M15.5 6.8c-.5-.8-.4-1.6.3-2 .7-.5 1.5-.2 2 .6s.3 1.6-.4 2c-.6.5-1.4.2-2-.6Zm1.7-1c-.3-.6-.7-.7-1-.5-.4.2-.5.6-.1 1.1.3.6.7.8 1 .6.4-.3.4-.7.1-1.2Z" />

			<path d="M18.7 5c-.5-1 0-1.8.6-2.1.4-.2.7-.1 1 0l-.2.5h-.6c-.3.2-.5.7-.2 1.2.2.6.7.8 1 .6.3-.1.4-.3.5-.5l.5.2c-.1.4-.3.7-.7.8-.7.3-1.5.1-2-.8Z" />

			<path d="m21.4 2.1.6-.2 1 2.8-.6.2-1-2.8Z" />

			<path d="M24 1.2 25 1l1.7 2.7-.7.1-.8-1.3-.4-1v2.7l-.7.2V1.2Zm.2 1.8 1.4-.4.2.5-1.4.4-.2-.5Z" />

			<path d="m26.9.5.7-.1.3 2.4 1.2-.2v.6l-1.8.3-.4-3Z" />

			<path d="m29.8.1 2-.1v.6h-1.2v.7l1-.1v.6h-1v.7H32V3l-1.9.1-.2-3Z" />
		</g>

		<g v-if="!avatar">
			<path d="M100.1 45V30.6h3.8v14.6c0 .8.4 1 .7 1h.5l.5 2.9a5 5 0 0 1-2 .3c-2.6 0-3.5-1.7-3.5-4.4Z" />

			<path d="m75.7 40.4 3.8-8.5h4V49h-3.6V38.4l-3 7.8h-2.4l-3-7.8v10.7H68V32h4l3.8 8.5Z" />

			<path d="M107.1 45.5c0-2.8 2.3-4.3 7.4-4.9 0-1.1-.8-1.8-2.2-1.8-1 0-2.1.4-3.4 1.2l-1.3-2.6c1.6-1 3.5-1.7 5.5-1.7 3.3 0 5 1.9 5 5.9V49h-3.5v-1.3s-1.5 1.6-3.6 1.6c-2.4 0-3.9-1.7-3.9-4Zm7.4-.3V43c-2.7.3-3.7 1.2-3.7 2.2 0 .8.5 1.2 1.5 1.2.8 0 1.5-.5 2.2-1.2Z" />

			<path d="M86.1 45.5c0-2.8 2.3-4.3 7.4-4.9 0-1.1-.8-1.8-2.2-1.8-1 0-2.1.4-3.4 1.2l-1.3-2.6c1.6-1 3.5-1.7 5.5-1.7 3.3 0 5 1.9 5 5.9V49h-3.5v-1.3S92 49.4 90 49.4c-2.4 0-3.9-1.7-3.9-4Zm7.4-.3V43c-2.7.3-3.7 1.2-3.7 2.2 0 .8.6 1.2 1.5 1.2.8 0 1.6-.5 2.2-1.2Z" />

			<path d="M129 30.6v6.3a4.1 4.1 0 0 0-3.2-1.2c-2.7 0-5.3 2.6-5.3 6.8 0 4.3 2 7 5.2 7 1.8 0 3.1-1.4 3.2-1.5v1.1h3.8V30.6H129Zm-2.3 15.7c-1.5 0-2.4-1.2-2.4-3.8 0-2.5 1.1-3.6 2.4-3.6.6 0 1.4.2 2.2.8v5.4c-.7.8-1.4 1.2-2.2 1.2Z" />

			<path d="M135.7 32c0-1.2 1-2 2.2-2 1.2 0 2.2.8 2.2 2s-1 2-2.2 2c-1.3 0-2.2-.8-2.2-2Zm.3 4h3.8V49H136V36Z" />

			<path d="M142.2 42.5c0-4.2 2.6-6.8 5.9-6.8 3.6 0 5.6 2.7 5.6 6.3l-.1 1.7h-7.7c.3 2 1.6 2.8 3.3 2.8 1 0 1.8-.4 2.8-1l1.3 2.5c-1.3.9-3 1.4-4.6 1.4-3.8 0-6.5-2.5-6.5-6.9Zm8.3-1.4c0-1.4-.9-2.5-2.4-2.5-1.2 0-2 .9-2.3 2.5h4.7Z" />

			<path d="M68 23.3V8.8h3.7v14.7c0 .8.4 1 .7 1h.5l.4 2.9a5 5 0 0 1-1.9.3c-2.6 0-3.5-1.7-3.5-4.4Z" />

			<path d="m88.1 23.3 1 4.1h4l-5.3-17.3h-4.4l-5.3 17.3h4l1-4.1h5Zm-4.2-3 1.6-6.6h.2l1.6 6.5H84Z" />

			<path d="m93.9 25.9 1.7-2.4c1.1.9 2.2 1.3 3.3 1.3 1.1 0 1.6-.4 1.6-1 0-1-1.2-1.4-2.6-1.9-1.6-.6-3.4-1.7-3.4-3.8 0-2.5 2-4.2 5-4.2 1.9 0 3.4.8 4.5 1.7l-1.7 2.4c-1-.7-1.8-1.2-2.8-1.2-1 0-1.4.4-1.4 1 0 1 1.2 1.2 2.5 1.7 1.6.7 3.5 1.6 3.5 4s-1.9 4.2-5.3 4.2c-1.7 0-3.6-.7-5-1.8Z" />

			<path d="m105.3 25.9 1.7-2.4c1.1.9 2.2 1.3 3.3 1.3 1.1 0 1.6-.4 1.6-1 0-1-1.2-1.4-2.6-1.9-1.6-.6-3.4-1.7-3.4-3.8 0-2.5 2-4.2 5-4.2 1.9 0 3.4.8 4.5 1.7l-1.7 2.4c-1-.7-1.8-1.2-2.8-1.2-1 0-1.4.4-1.4 1 0 1 1.2 1.2 2.5 1.7 1.6.7 3.5 1.6 3.5 4s-1.9 4.2-5.3 4.2c-1.7 0-3.6-.7-5-1.8Z" />

			<path d="M132.2 14.3h3.8V16c.8-1.4 2.5-2 3.4-2 .8 0 1.2.2 1.6.3l-.4 3.6c-.5-.2-1.1-.4-1.7-.4-1.5 0-2.8 1.3-2.9 3v6.8h-3.8V14.3Z" />

			<path d="M155.7 14.3h3.8v1.6c1-1 2.2-2 4-2 2.7 0 4 2 4 5.3v8.2h-3.9v-7.7c0-1.9-.5-2.5-1.6-2.5-1 0-1.6.5-2.5 1.3v8.8h-3.8v-13Z" />

			<path d="M180.6 20.8c0-4.3 2.7-6.9 5.9-6.9 3.7 0 5.7 2.8 5.7 6.3 0 .7 0 1.4-.2 1.8h-7.7c.4 1.9 1.7 2.8 3.4 2.8 1 0 1.8-.4 2.7-1l1.3 2.4c-1.3 1-3 1.5-4.6 1.5-3.7 0-6.5-2.5-6.5-6.9Zm8.4-1.4c0-1.4-.9-2.5-2.4-2.5-1.2 0-2 .8-2.3 2.5h4.7Z" />

			<path d="M141.8 23.7c0-2.7 2.3-4.3 7.4-4.8 0-1.2-.8-1.9-2.2-1.9a7 7 0 0 0-3.4 1.2l-1.3-2.5c1.6-1 3.4-1.8 5.5-1.8 3.3 0 5 2 5 6v7.5h-3.6V26s-1.4 1.6-3.5 1.6c-2.4 0-4-1.7-4-4Zm7.4-.2v-2.3c-2.7.4-3.8 1.3-3.8 2.3 0 .8.6 1.2 1.5 1.2s1.7-.5 2.3-1.2Z" />

			<path d="M76.7 8.8c-.8 0-1.9.6-1.9 1.7 0 1 .8 1.5 1.6 1.5 0 1.2-1 1.8-1.5 2.1l1 1.4c3.3-1 4-6.7.8-6.7Z" />

			<path d="M125.3 14.3V23c-.8 1-1.4 1.4-2.3 1.4-1 0-1.6-.6-1.6-2.5v-7.6h-3.8v8.3c0 3 1.4 5.1 4 5.1 2.5 0 3.8-1.6 3.8-1.6v1.3h3.7V14.3h-3.8Z" />

			<path d="M176.3 24.6c-1.7 0-3-1.5-3-3.7 0-2.3 1.3-3.8 3-3.8.6 0 1.1.2 1.7.7l1.8-2.5c-.9-.8-2.1-1.3-3.7-1.3a6.5 6.5 0 0 0-6.6 6.9c0 4.3 2.7 6.8 6.3 6.8 1.4 0 3-.4 4.2-1.5l-1.4-2.7c-.7.6-1.5 1-2.3 1Z" />
		</g>

		<path d="M34.8 9c-.1-.2-.4-.3-.6-.3H34c-.2-.2-5.3 0-6.5.7 0-.8-.4-1.8-1.7-2-1-.3-3.1.7-2.4 2.8 0 .3.3.6.7.8.2 0 .5 0 .7.6h.3l.2.2h.5c.4.4.8-.1 1-.5l.7 2c-.2-.2-1.8-.6-2.5.2s-1.2 1.8-1.7 3.5c-.2.4-.5.7-1 .9-.9.3-.4.7-.2.7a6 6 0 0 0 2 0c.4-.2.1-1 .5-1.4l.8-1c0 .5 0 .8-.3 1.5-.2.7-1 1-1.3 1.3-.4.5.6.5.8.5.7-.2 1-.2 1.3-.4.4-.2.2-.8.3-1 .3-.7 1.4-2 1.6-2.3.8.2 1.7.2 2 .2 1.9-.2 2.3-1.5 2-2.6-.1-1-.7-1.5-.9-1.8l-.9-1.4 3.5-.9c0 .3.3.3.4.4.2.1.3 0 .2-.1a.6.6 0 0 1-.2-.2h.7c.3 0 .4-.4.3-.5Z" />

		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M61 26.7c-.5-2.6-2.9-4.1-4.1-4.7l-1.4-.4-.4-.2c.1-.5.8-.5 1.2-1.3 1-2.3-1.2-3.8-2.8-3.5-.8.2-1.3.4-1.5 1 0 .4-.3.4-.7.8-.2.2.1.4.2.5l-.1.3v.5s-.3.3 0 .7l.3.8c0 .1 0 .2-.3 0l-3.4-1a37.4 37.4 0 0 1-4.2-4.7c-.7 0 .5 1.3-.1.8-.2 0-.7-.4-.8-.5l-.1-.2-.3-.3H42.2c-.2 0-.1.5 0 .7 0 0 .4 1.2.6 1.4l1.5 1 2.6 3c.7.7 3.8 2.5 3.9 2.6.2 0 .5.8 0 5.5-.1 1.8-1.4 5.6-.8 7.5.4 1.3.9 2.2 1.3 5.6.1.8-.5 1.3-1.3 2l-1.4.8c-.2.2 0 .4.2.5.2 0 .5.3.8.3.3.1.9 0 1.4-.3.7-.3.7-.4 1-.6.5-.3 1-.3 1.2-.8.2-.6-.3-1.4-.3-1.7.4-2.8.9-4.1.2-5.8-.2-.3 1-4 1-3.4.2.9.3 3.8.3 5.9 0 .9.8 4.2 1 5.4.4 1.8-2.6 3.2-2 3.8l1 .3 1-.1c.3-.1.6-.5.7-.6.6-.8.4-.6 1-1.1.4-.5 0-1.4 0-1.8v-2.9c0-1.9 0-2.4.2-3.2l1-6.2s.2 0 .3-.2c.2-.2.1-.5.2-.7 0-.2 0 0 0 0l.2.6-.2.8c-.2.4.1.4.2.5 0 0 1-.7 1.2-1l.1-.8-.2-1.8c.2-.9 1-3.2.8-3.8Zm-2.2 3.6c-.2.5-.2 0-.6 1.7V31.1c0-2.1-1.5-6.5-.6-5.6 0 0 1.2.8 1.4 1.4.2.5.1 1.8-.2 3.4Z"
		/>

		<path d="M20 35.3c-.3-.3-1.6-2-2.4-2.7l-1-1.5c-1.6-2-1.9-2.1-3-2.2-.1-.2 0-.3 0-.4 1.3-.5.9-1.6.8-1.7l.2-.6-.2-1-.1-.7c-.8-.9-2.6-.9-3.5-.3-.8.5-.3.9-.6 1.6-.1.5 0 .9.3 1.2 0 .3.8.7.7 1.2-.2.6-1 .7-1 .7l-.3.1c-1.4.8-2.7 2-2.9 3.2 0 1 1.7 2.5 2.7 3.3.1 1.7 1.2 4.4 1.3 4.5.1.3-.3-.3-1.4-.7-.6-.1-1.2-.9-1.4 0 0 .4 0 1-.3 1.8-.2.6 0 1.5.7 1.5.5 0 .8-1.4.8-1.4s2.3 1 3.3.7c.7-.2.8-2.7.2-5-.2-.8.4 1.3 2 3.1.2.4 0 .7.2 2.2v1c0 .7-.7 1.6.9 2 1.6.4 1.5.8 2.5.1.5-.3-1.4-.5-1.8-1.6v-.2c0-.9.3-2.9.2-3.6-.6-3.4-2-5-2.2-5.8 0-2.4-.2-3.2 0-2.6l1 1.5.3.3.4.4 2.8 2.1s.1 1 .6 1c.4 0 2.3-1 2.2-1.1 0-.3-2-.3-2-.4ZM9.7 34l-1-1.8c.4-.7 1-1 1-.9.2 0 0 2.7 0 2.7Z" />

		<path d="M51.8 54.8c-.1 0-1.2-.5-2.2-2-.5-.8-3.8-7-4.3-8.2-.9-2.4-8-6.7-8.2-7-.2-.1-.2-.5-.1-.8.5-2 .3-3.8.4-4.1.3-.7.8-1.7.4-2.3l-.7-1.2s3.7 1.4 4.6 1.2c.8-.2 4.5-2.8 4.7-2.9.5-.2 1.8.1 3-1.3.5-.5.2-.6 0-.6.1 0-.1-.2-.4 0-.2.1-1.3.4-1.1.2.8-.5.2-.7.2-.7-.3.3-1.8.7-2.1 1l-.8.5c-.9.5-2.4 1.3-4 1.7-.3 0-3.3-2-5-2.2-1-.1-1.3 0-1.8.1-.6.2-.6-.7 0-1 .2 0 .6-.1.7-.4.2-.4 0-.7 0-.8v-.2l-.1-.1v-.5c.3-.2.2-.4.1-.4-.1-.1-.6-.4-.7-.7 0-.6-.3-.9-.3-1.2 0 0-.1-.8-.4-1-.4-.4-1.2-.8-2.8-.3-.6.1-.5.4-1.8.6-1.6.3-2.4 2.7-2.3 3.7.1.8.8.4.8.7 0 .6-.1 1.5 1 1.8.3 0 1.8-.2 2.4 0 0 0 .5 0 .2.4-.1.2-1.6.9-2 1-1 .4-3.6 4.6-4.3 5-.7.3-1 .6-1.3.8-1 .6-2.1 1.4-2.7 1.4-.7 0-1.4.3-1.9 1.5-.1.3 0 .5.3.5 0 .1.2.3.4.3.2.2.5 0 .7 0l1-.7c.5-.2 4-1.5 4.7-2.1 1.2-.6 3.5-3 4-3s1.6 1 1.2 3c0 .7-1 2-1.4 2.6-1 1.5-.2 2.7-.4 3-1 1.6-2.2 3.7-4.2 5.5-.8.6-2.4.7-3.3 1-2 .5-4.2 2-5.7 2.8-.5.3-1-.3-1.6-.4-.7 0-.7 1-1 1.8l-.7 1.5c-.1.4-.7 1.7-.1 2.2.4.7 1.5-1.4 2.4-2.3.4-.5.7-.7 1.7-1 .6 0 5.6-1.4 8.8-2.2h.3c4.2-1.1 8.6-6.6 8.7-6.6l7.2 3.5c.7.4.7 1.8 1.5 3.4a22 22 0 0 0 4.4 4.9c.4.4 0 1 .2 1.6.2.6.6.6 1.1.6l1.6-.2c.7 0 .5 0 1.3.2.4 0 1.3.1 2-.5 1-1.2-1.2-.6-2.3-1.1Z" />

		<path d="M44 51.7a.4.4 0 0 0-.6-.2 22.2 22.2 0 0 1-21-.6.5.5 0 0 0-.6.2c-.1.2 0 .4.1.6a23 23 0 0 0 21.9.5c.2 0 .3-.3.2-.5Z" />

		<path d="M12.9 22.9h-.2c-.2-.2-.3-.4-.2-.6 2-4.4 5.2-8 9.3-10.4.2-.1.5 0 .6.2.2.2 0 .4-.1.6-4 2.3-7.1 5.7-9 10l-.4.2Z" />

		<path d="M50.3 17.3c-.1 0-.3 0-.3-.2A22 22 0 0 0 36.5 10c-.2 0-.4-.3-.3-.5 0-.3.2-.4.5-.4a23 23 0 0 1 14 7.5v.7h-.4Z" />
	</svg>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';

	import { tokens } from '@cnamts/design-tokens';

	import { locales } from './locales';

	import { LogoSizeEnum, LOGO_SIZE_ENUM_VALUES } from './LogoSizeEnum';

	import {
		logoDimensionsMapping,
		logoAvatarDimensionsMapping
	} from './logoDimensionsMapping';

	import { propValidator } from '../../helpers/propValidator';
	import { Dimensions } from '../../types';

	const Props = Vue.extend({
		props: {
			hideSignature: {
				type: Boolean,
				default: false
			},
			hideOrganism: {
				type: Boolean,
				default: false
			},
			risquePro: {
				type: Boolean,
				default: false
			},
			ariaLabel: {
				type: String,
				default: undefined
			},
			avatar: {
				type: Boolean,
				default: false
			},
			dark: {
				type: Boolean,
				default: false
			},
			size: {
				type: String,
				default: LogoSizeEnum.NORMAL,
				validator: (value: string) => propValidator('size', LOGO_SIZE_ENUM_VALUES, value)
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component
	export default class Logo extends MixinsDeclaration {
		risqueProColor = tokens.colors.risquePro;

		get fillColor(): string {
			if (this.dark) {
				return '#fff';
			}

			return tokens.colors.primary;
		}

		get dimensions(): Dimensions {
			if (this.avatar) {
				return logoAvatarDimensionsMapping[this.size];
			}

			return logoDimensionsMapping[this.size];
		}

		get viewBox(): string {
			if (this.avatar) {
				return '0 0 64 64';
			}

			if (this.hideSignature) {
				return '0 0 206 64';
			}

			return '0 0 211 64';
		}

		get label(): string {
			if (this.ariaLabel) {
				return this.ariaLabel;
			}

			if (this.avatar) {
				// Return an empty string since there is no text,
				// this is an illustration image
				return '';
			}

			const COLON_SEPARATOR = ' : ';
			const COMMA_SEPARATOR = ', ';

			let label = `${locales.assuranceMaladie}`;

			if (!this.hideOrganism) {
				label = locales.organism.concat(COMMA_SEPARATOR, label);
			}

			if (!this.hideSignature) {
				label = label.concat(COLON_SEPARATOR, locales.signature);
			}

			if (this.risquePro) {
				label = label.concat(COLON_SEPARATOR, locales.risquePro);
			}

			return label;
		}
	}
</script>
